// extracted by mini-css-extract-plugin
export default {"wrapper":"ExportExcelButton_wrapper__CHS72","btn":"ExportExcelButton_btn__ivd1P","error":"ExportExcelButton_error__tnTT+"};